// Genera y descarga el PDF del reporte financiero.
//
// Calcado de emailReportPdf.ts: react-pdf entra por import() DINAMICO para que
// las ~1.5MB del renderer + las fuentes NO esten en el bundle inicial del
// backoffice — solo bajan cuando alguien aprieta "Bajar PDF".
//
// Client-side y no una Lambda: cero infra nueva, sin cold start, sin layer de
// chromium.
//
// Si algun dia hace falta un reporte mensual automatico por mail, el documento
// (FinancialReportPdfDoc) se renderiza con renderToBuffer() del lado servidor
// — pero NO tal cual: los `import ... from '...ttf'` de las fuentes son assets
// de Vite y se compilan a una URL que el browser fetchea por HTTP. En node,
// react-pdf la trata como path de archivo y falla con ENOENT (verificado; el
// alias de Vite no alcanza, la transformacion a URL ocurre igual). Portarlo
// implica registrar las fuentes desde el filesystem con Font.register({ src:
// <path absoluto> }). El resto del componente ya es puro y no cambia.

import type { FinancialReport, TrialBalance } from '@/lib/api';

export function financialReportPdfFilename(report: FinancialReport): string {
  const partner = report.params.partner_id ?? 'todos';
  return `reporte-financiero-${partner}-${report.params.from}_${report.params.to}.pdf`;
}

export async function downloadFinancialReportPdf(args: {
  report: FinancialReport;
  trialBalance: TrialBalance;
  partnerLabel: string;
  generatedBy: string;
}): Promise<void> {
  const [{ pdf }, { default: FinancialReportPdfDoc }] = await Promise.all([
    import('@react-pdf/renderer'),
    import('@/lib/pdf/FinancialReportPdfDoc'),
  ]);

  const blob = await pdf(
    FinancialReportPdfDoc({
      report: args.report,
      trialBalance: args.trialBalance,
      partnerLabel: args.partnerLabel,
      generatedBy: args.generatedBy,
    }),
  ).toBlob();

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = financialReportPdfFilename(args.report);
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Diferido: revocar en el mismo tick cancela la descarga en algunos browsers.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
